import type { IHeaderParams } from 'ag-grid-community';
import { useState } from 'react';
import { HeaderComponentDefault } from './HeaderComponentDefault';

export function HeaderComponent(props: IHeaderParams): JSX.Element {
    const [anchorEl, setAnchorEl] = useState<null | Element>(null);

    return <HeaderComponentDefault {...props} anchorEl={anchorEl} setAnchorEl={setAnchorEl} />;
}
